import { TopBarRoute } from "components/templates";
import { Icon, Stack, Title } from "@introist/react-foundation/v2";
import { CollapseList, IconPickerIcon, StyledListRow } from "components/organisms";
import { api, RouterOutput } from "services/rpc/RpcProvider";
import { Skeletons } from "components/molecules";
import { useNavigate } from "react-router";
import { useLocalStorage } from "usehooks-ts";

type TemplateCategory = RouterOutput["workflows"]["templates"]["categories"][0];
type WorkflowTemplate = RouterOutput["workflows"]["templates"]["templates"][0];

export const TemplatesRoute = () => {
  const navigate = useNavigate();
  const { data: categories } = api.workflows.templates.categories.useQuery({});
  const { data: templates } = api.workflows.templates.templates.useQuery({});
  const [openCategories, setOpenCategories] = useLocalStorage<string[]>(
    "intr.library.openCategories",
    []
  );

  const toggleCategory = (categoryId: string) => {
    setOpenCategories(prev => {
      if (prev.includes(categoryId)) {
        return prev.filter(id => id !== categoryId);
      } else {
        return [...prev, categoryId];
      }
    });
  };

  const isLoading = !categories || !templates;

  return (
    <TopBarRoute title="Library">
      <Stack vertical>
        {isLoading && <Skeletons.List rowCount={5} />}
        {!isLoading &&
          categories?.map((category: TemplateCategory) => {
            const templatesInCategory = (templates ?? []).filter(
              (template: WorkflowTemplate) => template.folderId === category.id
            );
            return (
              <CollapseList
                key={category.id}
                header={<Title>{category.name}</Title>}
                open={openCategories.includes(category.id)}
                onToggleOpen={() => toggleCategory(category.id)}
              >
                {(templatesInCategory ?? []).map((template: WorkflowTemplate) => (
                  <StyledListRow
                    key={template.id}
                    $gridTemplateColumns="40px 1fr 3fr 16px"
                    style={{ marginTop: "-1px" }}
                    $clickable={true}
                    onClick={() => navigate(`/templates/${template.id}`)}
                  >
                    <IconPickerIcon fallbackIcon="workflows" />
                    <Title variant="bold">{template.title}</Title>
                    <Title small>{template.description}</Title>
                    <Icon name="chevronRight" />
                  </StyledListRow>
                ))}
              </CollapseList>
            );
          })}
      </Stack>
    </TopBarRoute>
  );
};
